<div class="page">
  <app-configurator *ngIf="appReady"></app-configurator>
  <app-loading *ngIf="!appReady"></app-loading>
  <app-modal id="modal-project-error-font" width="640" [blocking]="true">
    <div class="tip-text" [innerHtml]="'cfg_projectLoadError_font' | translate"></div>
  </app-modal>
</div>
